import { render, staticRenderFns } from "./dictionary_item.vue?vue&type=template&id=ba4df9fe&"
import script from "./dictionary_item.vue?vue&type=script&lang=js&"
export * from "./dictionary_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports